module.exports = __webpack_public_path__ + "img/29_50.e393752e.png";